import { apiCall, createQueryString } from "../imports"

const PREFIX = "shop/brands"

export default {

    get(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`)
    },

    find(id) {
        return apiCall('get', `${PREFIX}/${id}`)
    },

    create(data) {
        return apiCall('post', `${PREFIX}`, data)
    },

    update(orderId, data) {
        return apiCall('post', `${PREFIX}/${orderId}/update`, data)
    },

    delete(orderID) {
        return apiCall('delete', `${PREFIX}/${orderID}`)
    }
}